import clsx from 'clsx';
import React, { memo } from 'react';

import type { AIEventUserMessage } from '@doger/core/shared/api';

import styles from './user-message.module.scss';

type UserMessageProps = {
  message: AIEventUserMessage;
  className?: string;
};

export const UserMessage = memo(({ message, className }: UserMessageProps) => (
  <div className={clsx(styles.message, className)}>
    <div className={styles.message__container}>
      <div className={styles.message__content}>
        <div className={styles.message__text}>{message.text}</div>
      </div>
    </div>
  </div>
));
